import type { HelpFile } from '../../types/help'
import { ProvisioningTaskDetailTestIds } from '../../../testids/ProvisioningTaskDetailTestIds'

export const provisioningTaskDetailHelp: HelpFile = {
  docPage: '/docs/provisioning/provisioning-tasks',
  texts: {
    [ProvisioningTaskDetailTestIds.taskDetailTitle]: null,
    [ProvisioningTaskDetailTestIds.taskInfoCard]: 'Task summary — identity, action, Enforcement Object, and target system.',
    [ProvisioningTaskDetailTestIds.errorCard]: 'Error details for a failed Provisioning Task — error message and link to the full error log entry.',
    [ProvisioningTaskDetailTestIds.timelineCard]: 'Status history — from task creation through completion or failure.',
    [ProvisioningTaskDetailTestIds.timelineEntries]: null,
    [ProvisioningTaskDetailTestIds.statusBadge]: null,
    [ProvisioningTaskDetailTestIds.errorMessage]: null,
    [ProvisioningTaskDetailTestIds.errorLogLink]: null,
    [ProvisioningTaskDetailTestIds.linkIdentity]: null,
    [ProvisioningTaskDetailTestIds.linkTargetSystem]: null,
    [ProvisioningTaskDetailTestIds.btnRetryTask]:
      'Re-queue this Provisioning Task. The task is reset to pending and the connector tries again on the next sweep.',
    [ProvisioningTaskDetailTestIds.nextRetryAt]: 'Scheduled time of the next automatic retry attempt. Only shown when the task is waiting out its backoff window.',
  },
}
